import { Injectable } from '@angular/core';
import { IonContent } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class HelperService {

    public countries: any[] = [
        {
            code: 'COUNTRY.FR.CODE',
            name: 'COUNTRY.FR.NAME',    
            flag: 'assets/flags/france.png',
            callingCode: '+33',
            placeholder: "06 12 34 56 78",
            phoneMask: "00 00 00 00 00",
            regex: new RegExp(/^06|07/)
        },    
        {
            code: 'COUNTRY.BE.CODE',    
            name: 'COUNTRY.BE.NAME',    
            flag: 'assets/flags/belgium.jpg',
            callingCode: '+32',
            placeholder: "0495 12 34 56",
            phoneMask: "0000 00 00 00",
            regex: new RegExp(/^04|0495/)
        },    
        {
            code: 'COUNTRY.CH.CODE',    
            name: 'COUNTRY.CH.NAME',    
            flag: 'assets/flags/switzerland.png',
            callingCode: '+41',
            placeholder: "075 123 4567",
            phoneMask: "000 000 0000",
            regex: new RegExp(/^075|076|077|078|079/)
        },    
        {
            code: 'COUNTRY.DE.CODE',    
            name: 'COUNTRY.DE.NAME',    
            flag: 'assets/flags/germany.png',
            callingCode: '+49', 
            placeholder: "01234 5678901",
            phoneMask: "00000 000000000",
            regex: new RegExp(/^01|02/)
        },    
        {
            code: 'COUNTRY.AD.CODE',    
            name: 'COUNTRY.AD.NAME',    
            flag: 'assets/flags/andorra.png',
            callingCode: '+376', 
            placeholder: "12 34 56789",
            phoneMask: null,
            regex: new RegExp(/^[0-9]/)
        },  
        {
            code: 'COUNTRY.CM.CODE',    
            name: 'COUNTRY.CM.NAME',    
            flag: 'assets/flags/cameroun.png',
            callingCode: '+237',   
            placeholder: "661 23 45 67",
            phoneMask: "000 00 00 00",
            regex: new RegExp(/^66|67|65|69/)
        },   
        {
            code: 'COUNTRY.CA.CODE',    
            name: 'COUNTRY.CA.NAME',    
            flag: 'assets/flags/canada.png',
            callingCode: '+1',   
            placeholder: "123 456 7890",
            phoneMask: "000 000 0000",
            regex: new RegExp(/^[0-9]/)
        },  
        {
            code: 'COUNTRY.CI.CODE',    
            name: 'COUNTRY.CI.NAME',    
            flag: 'assets/flags/cote_ivoire.png',
            callingCode: '+225',   
            placeholder: "01 23 45 6789",
            phoneMask: "00 00 00 0000",
            regex: new RegExp(/^01|05|07/)
        }, 
        {
            code: 'COUNTRY.DK.CODE',    
            name: 'COUNTRY.DK.NAME',    
            flag: 'assets/flags/denmark.png',
            callingCode: '+45',   
            placeholder: "20 12 34 56",
            phoneMask: "00 00 00 00",
            regex: new RegExp(/^20|31|40|42|50|53|60|61|71|81|91|93/)
        },    
        {
            code: 'COUNTRY.ES.CODE',    
            name: 'COUNTRY.ES.NAME',    
            flag: 'assets/flags/spain.png',
            callingCode: '+34',
            placeholder: "712 34 56 78",
            phoneMask: "000 0 00 00",
            regex: new RegExp(/^7|6/)
        },    
        {
            code: 'COUNTRY.FR-GP.CODE',
            name: 'COUNTRY.FR-GP.NAME',
            flag: 'assets/flags/guadeloupe.png',
            callingCode: '+590',   
            placeholder: "691 23 45 67",
            phoneMask: "000 00 00 00",
            regex: new RegExp(/^690|691/)
        },
        {
            code: 'COUNTRY.GR.CODE',
            name: 'COUNTRY.GR.NAME',
            flag: 'assets/flags/greece.png',
            callingCode: '+30',   
            placeholder: "61 2345 6789",
            phoneMask: "00 0000 0000",
            regex: new RegExp(/^6/)
        },    
        {
            code: 'COUNTRY.FR-GN.CODE',
            name: 'COUNTRY.FR-GN.NAME',
            flag: 'assets/flags/guyane.png',
            callingCode: '+594',   
            placeholder: "0694 12 34 56",
            phoneMask: "0000 00 00 00",
            exemple: "0694 29 10 11",
            regex: new RegExp(/^694/)
        },
        {
            code: 'COUNTRY.IE.CODE',    
            name: 'COUNTRY.IE.NAME',    
            flag: 'assets/flags/ireland.png',
            callingCode: '+353',
            placeholder: "(08) 312 3456",
            phoneMask: "(00) 000 0000",
            regex: new RegExp(/^083|085|086|087|089/)
        },
        {
            code: 'COUNTRY.IT.CODE',    
            name: 'COUNTRY.IT.NAME',    
            flag: 'assets/flags/italy.png',
            callingCode: '+39',
            placeholder: "312 345 6789",
            phoneMask: "XXX XXX XXXX",
            exemple: "393 516 0211",
            regex: new RegExp(/^3/)
        },
        {
            code: 'COUNTRY.LI.CODE',
            name: 'COUNTRY.LI.NAME',
            flag: 'assets/flags/liechtenstein.png',
            callingCode: '+423',   
            placeholder: "639 12 34",
            phoneMask: "000 00 00",
            regex: new RegExp(/^639|692|693/)
        },    
        {
            code: 'COUNTRY.LU.CODE',    
            name: 'COUNTRY.LU.NAME',    
            flag: 'assets/flags/luxembourg.png',
            callingCode: '+352',
            placeholder: "651 234 567",
            phoneMask: "000 000 000",
            exemple: "651 382 467",
            regex: new RegExp(/^6[2569]1/)
        },    
        {
            code: 'COUNTRY.MA.CODE',
            name: 'COUNTRY.MA.NAME',
            flag: 'assets/flags/morocco.png',
            callingCode: '+212',   
            placeholder: "0612-345678",
            phoneMask: "0000-000000",
            exemple: "0610-182137",
            regex: new RegExp(/^[0-9]/)
        },    
        {
            code: 'COUNTRY.FR-MT.CODE',
            name: 'COUNTRY.FR-MT.NAME',
            flag: 'assets/flags/martinique.png',
            callingCode: '+596',   
            placeholder: "0696 12 34 56",
            phoneMask: "0000 00 00 00",
            exemple: "0696 67 62 70",
            regex: new RegExp(/^696|697/)
        },    
        {
            code: 'COUNTRY.FR-MA.CODE',
            name: 'COUNTRY.FR-MA.NAME',
            flag: 'assets/flags/mayotte.png',
            callingCode: '+269',   
            placeholder: "639 12 34 56",
            phoneMask: "000 00 00 00",
            regex: new RegExp(/^639/)
        },    
        {
            code: 'COUNTRY.MC.CODE',    
            name: 'COUNTRY.MC.NAME',    
            flag: 'assets/flags/monaco.png',
            callingCode: '+377',   
            placeholder: "01 23 45 67",
            phoneMask: "00 00 00 00",
            regex: new RegExp(/^[0-9]/)
        },    
        {
            code: 'COUNTRY.FR-NC.CODE',
            name: 'COUNTRY.FR-NC.NAME',
            flag: 'assets/flags/nouvelle_caledonie.png',
            callingCode: '+687',   
            placeholder: "01.23.45",
            phoneMask: "00.00.00",
            regex: new RegExp(/^[0-9]/)
        },    
        {
            code: 'COUNTRY.NL.CODE',
            name: 'COUNTRY.NL.NAME',
            flag: 'assets/flags/netherlands.png',
            callingCode: '+31',   
            placeholder: "06 12345678",
            phoneMask: "00 00000000",
            regex: new RegExp(/^06/)
        },    
        {
            code: 'COUNTRY.FR-PL.CODE',
            name: 'COUNTRY.FR-PL.NAME',
            flag: 'assets/flags/polynesie.png',
            callingCode: '+689',   
            placeholder: "87 12 34 57",
            phoneMask: "00 00 00 00",
            regex: new RegExp(/^87|89/)
        },
        {
            code: 'COUNTRY.PT.CODE',    
            name: 'COUNTRY.PT.NAME',    
            flag: 'assets/flags/portugal.png',
            callingCode: '+351',
            placeholder: "012 345 678",
            phoneMask: "000 000 000",
            regex: new RegExp(/^[0-9]/)
        },    
        {
            code: 'COUNTRY.FR-RE.CODE',
            name: 'COUNTRY.FR-RE.NAME',
            flag: 'assets/flags/reunion.png',
            callingCode: '+262',   
            placeholder: "639 12 34 56",
            phoneMask: "000 00 00 00",
            regex: new RegExp(/^639|692|693/)
        },    
        {
            code: 'COUNTRY.FR-SB.CODE',
            name: 'COUNTRY.FR-SB.NAME',
            flag: 'assets/flags/saint_barth.png',
            callingCode: '+590',   
            placeholder: "0690 12 34 56",
            phoneMask: "0000 00 00 00",
            regex: new RegExp(/^0690|0691/)
        },    
        {
            code: 'COUNTRY.FR-SM.CODE',
            name: 'COUNTRY.FR-SM.NAME',
            flag: 'assets/flags/saint_martin.png',
            callingCode: '+590',   
            placeholder: "0690 12 34 56",
            phoneMask: "0000 00 00 00",
            regex: new RegExp(/^0690|0691/)
        },    
        {
            code: 'COUNTRY.FR-SPM.CODE',
            name: 'COUNTRY.FR-SPM.NAME',
            flag: 'assets/flags/saint_pierre_miquelon.png',
            callingCode: '+508',
            placeholder: "55 12 34",
            phoneMask: "00 00 00",
            regex: new RegExp(/^55/)
        },    
        {
            code: 'COUNTRY.GBR.CODE',    
            name: 'COUNTRY.GBR.NAME',    
            flag: 'assets/flags/united-kingdom.png',
            callingCode: '+44',
            placeholder: "071 2345 6789",
            phoneMask: "000 0000 0000",
            regex: new RegExp(/^07/)    
        },    
        {
            code: 'COUNTRY.TU.CODE',
            name: 'COUNTRY.TU.NAME',
            flag: 'assets/flags/tunisia.png',
            callingCode: '+216',
            placeholder: "01 234 567",
            phoneMask: "00 000 000",
            regex: new RegExp(/^[0-9]/)
        },    
        {
            code: 'COUNTRY.FR-WF.CODE',
            name: 'COUNTRY.FR-WF.NAME',
            flag: 'assets/flags/wallis_futuna.png',
            callingCode: '+681',   
            placeholder: "41 23 45",
            phoneMask: "00 00 00",
            regex: new RegExp(/^4|8/)
        } 
    ];
    
  constructor(private translate: TranslateService) {}

  public arrayConcatById<T>(
        arrayOld: T[],
        arrayNew: T[],
        key: string,
        order: string = 'DESC',
        secondaryKey: string = null,
    ): T[] {
        if (!arrayNew.length && !arrayOld.length) {
            return [];
        }
        const lead = arrayNew[0][key] as number;
        const last = arrayNew[arrayNew.length - 1][key] as number;

        arrayOld = arrayOld || [];
        arrayNew = arrayNew || [];
        arrayOld = arrayOld.filter((vol) => {
            return (
                (lead > last && ((vol[key] as number) >= lead || (vol[key] as number) <= last)) ||
                (lead < last && ((vol[key] as number) <= lead || (vol[key] as number) >= last)) ||
                (lead as number) === (last as number)
            );
        });

        let old: T[];
        if (secondaryKey !== null) {
            old = arrayOld.filter((vol) => {
                let flg = true;
                arrayNew.forEach((element) => {
                    if (element[secondaryKey] === vol[secondaryKey]) {
                        flg = false;
                    }
                });
                return flg;
            });
        } else {
            old = arrayOld;
        }

        const oldData = old.filter((vol) => {
            let flg = true;
            arrayNew.forEach((element) => {
                if (element[key] === vol[key]) {
                    flg = false;
                }
            });
            return flg;
        });
        let data = arrayNew.concat(oldData);

        let ord = -1;

        if (order === 'ASC') {
            ord = 1;
        }

        data = data.sort((a, b) => {
            const x = a[key] as number;
            const y = b[key] as number;
            if (x > y) {
                return ord;
            }
            if (x < y) {
                return ord * -1;
            }
            return 0;
        });

        return data;
    }

    public waitRendering(): Promise<void> {
        return Promise.race([
            new Promise<void>((resolve) => requestAnimationFrame(() => resolve())),
            new Promise<void>((resolve) => setTimeout(() => resolve())),
        ]);
    }

    public async toBottomAnimation(content: IonContent): Promise<void> {
        const scrollElement = await content.getScrollElement();
        if (scrollElement.scrollHeight - scrollElement.scrollTop - scrollElement.clientHeight > 200) {
          return;
        }
    
        const startTime = new Date().getTime();
        const toBottomAnimation = () => {
          if (new Date().getTime() - startTime <= 420) {
            content.scrollToBottom();
            requestAnimationFrame(toBottomAnimation);
          }
        };
        requestAnimationFrame(toBottomAnimation);
    }

    public checkMail(email:string){
        let fakeMails: string[] = ["24rumen.com","3mkz.com","abudat.com","adroh.com","avabots.com","bisongl.com","botsoko.com","cadolls.com","caeprisme.com","canyona.com","cdfaq.com","cebaike.com","charav.com","coooooool.com","corylan.com","deitada.com","dicopto.com","dineroa.com","dmtubes.com","dragonhosp.com","edxplus.com","ekbasia.com","eledeen.com","evilant.com","fexbox.com","fgvod.com","fgvods.com","gufum.com","haboty.com","haizail.com","harcity.com","hempyl.com","histoiresdegroupe.com","hostovz.com","hoxds.com","ilusale.com","imdutex.com","inkmoto.com","inpwa.com","invodua.com","ishyp.com","jernang.com","kaimdr.com","karenkey.com","katsy.com","keshitv.com","kixotic.com","klblogs.com","ktasy.com","kuvasin.com","lance7.com","lidely.com","lulota.com","lyricspad.net","mignonom.com","nezid.com","orlydns.com","panaweb.com","pianoxltd.com","rover.info","rumen.com","runbox.com","skerme.com","sopulit.com","sopulit.com","sunetoa.com","tmmcv.com","tmmwj.net","tofeat.com","vusra.com","xcoxc.com","yandex.com","yopmail.com"];
        if(email){
            let _mailDomain = email.split('@')[1];

            if(_mailDomain === undefined) return false;

            return fakeMails.find(m=>{
                return m === _mailDomain;
            }) === undefined;
        }else{
            return false;
        }
    }

    public checkPhone(phoneCode:any, phoneNumber:any) {
        let country = this.countries.find((c) => c.callingCode == phoneCode)
        return country && country.regex.test(phoneNumber) && (!country.phoneMask || (country.phoneMask && phoneNumber.length === country.phoneMask.replace(/[ .-]/g, "").length));
    }
}
